import { render } from "./trust-data-practices.html?vue&type=template&id=1cffcfd6&scoped=true&ts=true&external"
import script from "./trust-data-practices.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-practices.ts?vue&type=script&lang=ts&external"

import "./trust-data-practices.scss?vue&type=style&index=0&id=1cffcfd6&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cffcfd6"]])

export default __exports__